import React from "react";
import "../../Assessts/Styles/Galarry.scss";

import IOText from "../../ReUableComponents/ImageOntext";
import SEBanner from "../../Assessts/Images/Gallary/StudentEngagement/SEBanner.png";

import { Row, Col } from "react-bootstrap";

import SM1 from "../../Assessts/Images/Gallary/StudentEngagement/SM/SM1.png";
import SM2 from "../../Assessts/Images/Gallary/StudentEngagement/SM/SM2.png";
import SM3 from "../../Assessts/Images/Gallary/StudentEngagement/SM/SM3.png";
import SM4 from "../../Assessts/Images/Gallary/StudentEngagement/SM/SM4.png";
import SM5 from "../../Assessts/Images/Gallary/StudentEngagement/SM/SM5.png";
import SM6 from "../../Assessts/Images/Gallary/StudentEngagement/SM/SM6.png";


import SASK1 from "../../Assessts/Images/Gallary/StudentEngagement/SASK/SASK1.png";
import SASK2 from "../../Assessts/Images/Gallary/StudentEngagement/SASK/SASK2.png";
import SASK3 from "../../Assessts/Images/Gallary/StudentEngagement/SASK/SASK3.png";
import SASK4 from "../../Assessts/Images/Gallary/StudentEngagement/SASK/SASK4.png";
import SASK5 from "../../Assessts/Images/Gallary/StudentEngagement/SASK/SASK5.png";
import SASK6 from "../../Assessts/Images/Gallary/StudentEngagement/SASK/SASK6.png";

import SKMC1 from "../../Assessts/Images/Gallary/StudentEngagement/SKMC/SKMC1.png";
import SKMC2 from "../../Assessts/Images/Gallary/StudentEngagement/SKMC/SKMC2.png";
import SKMC3 from "../../Assessts/Images/Gallary/StudentEngagement/SKMC/SKMC3.png";
import SKMC4 from "../../Assessts/Images/Gallary/StudentEngagement/SKMC/SKMC4.png";
import SKMC5 from "../../Assessts/Images/Gallary/StudentEngagement/SKMC/SKMC5.png";
import SKMC6 from "../../Assessts/Images/Gallary/StudentEngagement/SKMC/SKMC6.png";
const SEngagement = () => {

    
  const SASK = [
        { img: SASK1 },
        { img: SASK2 },
        { img: SASK3 },
        { img: SASK4 },
        { img: SASK5 },
        { img: SASK6 },
    ];
     const SKMC = [
        { img: SKMC1 },
        { img: SKMC2 },
        { img: SKMC3 },
        { img: SKMC4 },
        { img: SKMC5 },
        { img: SKMC6 },
    ];
    const SMPeople = [
        { img: SM1 },
        { img: SM2 },
        { img: SM3 },
        { img: SM4 },
        { img: SM5 },
        { img: SM6 },
    ];

    const SEdata = [
        { Data: SASK, Tittle: "Seva Activites", SubTittle: "School Kit Distribution conducted for government school students." },
        { Data: SKMC,  SubTittle: "Medical camps conducted to support basic health assessment and preventive care." },
        { Data: SMPeople, Tittle: "Student Meet", SubTittle: "Student Meet conducted with a focus on academic interaction and skill development.", color: "#EFFFFB" },
    ];

    return (
        <>
            <div className="Single_Banner mt-2 mb-4">
                <IOText Image={SEBanner} Alt="EMpower" Text={<div className="Text-MainDiv w-100" >
                    <div >Academic <span style={{ color: "#F7D670" }}>Interaction Programs</span> Focused on
                        Learning, <span style={{ color: "#F7D670" }}>Skill Development, and Career Preparedness.</span></div>
                </div>} />
            </div>
            <div className="SEngagement">
                {SEdata.map((item) => (
                    <>
                        <div className="Web-MainHeading"> {item.Tittle}  </div>
                        <div className="Web-SubHeading"> {item.SubTittle}  </div>
                        <div className="container-fluid  mb-3 p-2">
                            <Row className="dflex  ">
                                {item.Data.map((item) => (
                                    <Col className="dflex  flexd-column alignitems mt-3" >
                                        <img src={item.img} alt="{`${item}`}" />
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    </>
                ))}
            </div>
        </>
    );
};
export default SEngagement;